export default "__VITE_ASSET__5e314044__"